export const getKeyForMigratingCompany = (companyId) => `migratingCompany_${companyId}`
